<template>
	<div class="entity-section-row">

		<div class="row page-heading mx-0">
			<div class="col-12 module_heading">
				<span class="module_icon fas fa-address-book" v-if="type === 'careers'"></span>
          		<span class="module_icon program_guide_icon icon-list" v-if="type === 'programs'"></span>
				<span class="module_type_name">{{type}}</span>
			</div>
		</div>

		<div class="entity-detail-row">
			<div class="row mx-0">
          		<template v-if="type === 'careers'">

					<div class="box" v-for="(career, index) in careerResultsToShow">
						<div class="thumnail-section" @click="goToCareerPage(career)">
            				<div v-if="career.thumbnailURI">
               					<img class="thumnail-img" :src="career.thumbnailURI">
            				</div>
            				<div class="ic_container" v-else>
								<div class="icon module_icon fas fa-address-book"></div>
							</div>
						</div>

						<div class="title" @click="goToCareerPage(career)" :title="career.name">{{career.name}}</div>

						<div class="top-row">
							<div class="left-field-section">
                				<b-link :disabled="career.bookmarked" @click="bookmarkCareer(career)"><span class="ic icon-bookmark"></span></b-link>
							</div>
							<div class="right-entity-section">
								<span class="module_icon fas fa-address-book"></span>
							</div>
						</div>
					</div>

          			<div class="empty_pattern no_results" v-if="careerResultsToShow.length === 0">No results</div>

         		</template>

         		<template v-if="type === 'programs'">

       				<div class="box" v-for="program in programResultsToShow">

         				<div class="thumnail-section" @click="goToProgramPage(program)">
           					<div v-if="program.thumbnailURI">
              					<img class="thumnail-img" :src="program.thumbnailURI">
           					</div>
           					<div class="ic_container" v-else>
           						<div class="icon program_guide_icon icon-list"></div>
           					</div>
         				</div>

         				<div class="title" @click="goToProgramPage(program)" :title="program.name">{{program.name}}</div>

         				<div class="top-row">
           					<div class="left-field-section">
                      			<b-link :disabled="program.bookmarked" @click="bookmarkProgram(program)"><span class="ic icon-bookmark"></span></b-link>
           					</div>
           					<div class="right-entity-section">
             					<span class="icon program_guide_icon icon-list"></span>
			               </div>
         				</div>

       				</div>

         			<div class="empty_pattern no_results" v-if="programResultsToShow.length === 0">No results</div>

        		</template>
			</div>

			<div class="read-more">
				<a @click="showMore()" v-if="enableShowMore">more {{type}}</a>
			</div>
		</div>

	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'exploreList',
  props: ['type'],
  components: {
  },
  data: () => {
    return {
      userObj: JSON.parse(localStorage.getItem('userobj')),
      isBookmarked: true
    }
  },

  mounted () {
    this.loadExploreList()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'setCurrentFacet',
      'loadCreateBookmarks'
    ]),
    loadExploreList () {
    },
    showMore () {
      this.setCurrentFacet(this.type)
    },
    goToCareerPage (career) {
      return this.$router.push({ name: 'careerDetail', params: { code: career.pragyaSoc } })
    },
    goToProgramPage (program) {
      let cipCode = ''
      if (program.cipCode) {
        cipCode = program.cipCode
      } else {
        cipCode = program.cipcode
      }
      return this.$router.push({ name: 'programGuideIntroduction', params: { programGuideCode: program.code, cipCode: cipCode, type: 'MAJOR' } })
    },
    bookmarkCareer (career) {
      let careerBookmark = {
        'entityType': 'career',
        'entityTitle': career.name,
        'entityUuid': career.uuid,
        'source': 'explore',
        'userId': this.userObj.uuid,
        'institutionId': this.userObj.institutionId
      }
      this.loadCreateBookmarks(careerBookmark).then(res => {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Successfully added to bookmarks!.'
        })
      })
      career.bookmarked = true
    },
    bookmarkProgram (program) {
      let programBookmark = {
        'entityType': 'program',
        'entityTitle': program.name,
        'entityUuid': program.uuid,
        'source': 'explore',
        'userId': this.userObj.uuid,
        'institutionId': this.userObj.institutionId
      }
      this.loadCreateBookmarks(programBookmark).then(res => {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'Successfully added to bookmarks!.'
        })
      })
      program.bookmarked = true
    }
  },

  computed: {
    ...mapState({
      'careerResults': state => state.explore.careerResults,
      'programResults': state => state.explore.programResults,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'currentFacet': state => state.explore.currentFacet
    }),
    careerResultsToShow () {
      if (this.currentFacet === this.type) {
        return this.careerResults
      } else if (this.currentFacet === 'all') {
        return this.careerResults.slice(0, 4)
      }
      return []
    },
    programResultsToShow () {
      if (this.currentFacet === this.type) {
        return this.programResults
      } else if (this.currentFacet === 'all') {
        return this.programResults.slice(0, 4)
      }
      return []
    },
    enableShowMore () {
      if (this.currentFacet === 'all') {
        if ((this.type === 'careers' && this.careerResults.length > 3) || (this.type === 'programs' && this.programResults.length > 3)) {
          return true
        }
      }
      return false
    }
  },

  watch: {
  }
}
</script>
<style>
.thumnail-img{
  width: 100px!important;
}
.disabled .icon-bookmark {
  color: orange;
}
</style>



// WEBPACK FOOTER //
// src/app/explore/components/ExploreList.vue